<div class="c-content c-content--wrapper" data-testid="bookings-list" [attr.data-loading]="!!vm.loading" [ngClass]="{'c-content--xxl': !vm.loading && !vm.bookings?.length, 'u-no-p@up-to-md': vm.loading || vm.bookings?.length}" [ngStyle]="vm.loading && {'min-height': '300px'}">
	<table-bookings [bookings]="vm.bookings" [pageSize]="vm.pageSize" [(currentPage)]="vm.currentPage" [status]="vm.activeTab.status" *ngIf="!vm.loading && vm.bookings?.length" (currentPageChange)="vm.currentPageChanged($event)"></table-bookings>
    <p class="c-text c-text--gray c-text--center c-text--lg c-text--md@up-to-md u-ost-md@up-to-md" *ngIf="!vm.loading && !vm.bookings?.length">
		{{ 'Booking.Other.NoContent' | translate }}
	</p>
	<loader-overlay *ngIf="vm.loading"></loader-overlay>
	<div *ngIf="!vm.loading && vm.bookings && vm.bookings?.length > vm.pageSize">	
		<div class="o-grid u-ost-md u-osb-md">
			<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
				<list-pager [totalItems]="vm.bookings?.length" [pageSize]="vm.pageSize" [(currentPage)]="vm.currentPage" (currentPageChange)="vm.currentPageChanged($event)"></list-pager>
			</div>
		</div>
	</div>
</div>
